<template>
  <div :id="'status' + status.id">
    <lazy-render
      v-for="record in statusRecords"
      :key="record.id"
      :min-height="128"
      unrender
      :data-record-id="record.id"
    >
      <active-record-item
        :record="record"
        :acceptable-time="status.acceptable_time"
      ></active-record-item>
    </lazy-render>

<!--    <modal-container>-->
<!--      <b-modal-->
<!--        :active.sync="isRecordRequiredDateModalOpen"-->
<!--        :can-cancel="false"-->
<!--        :width="400"-->
<!--        has-modal-card-->
<!--      >-->
<!--        <record-required-date-modal-->
<!--          :status="status"-->
<!--          :record="draggedRecord"-->
<!--          @requiredDateSet="update($event)"-->
<!--          @cancel="moveRecordBack"-->
<!--        ></record-required-date-modal>-->
<!--      </b-modal>-->
<!--    </modal-container>-->
  </div>
</template>

<script>
import ActiveRecordItem from "./ActiveRecordItem";
import Sortable from 'sortablejs';
import RecordRequiredDateModal from "../../../components/RecordRequiredDateModal";
import LazyRender from "../../../../../components/LazyRender";

export default {
  name: "ActiveColumnBody",
  components: {
    LazyRender,
    RecordRequiredDateModal,
    ActiveRecordItem,
  },
  props: {
    status: Object,
  },
  data() {
    return {
      isRecordRequiredDateModalOpen: false,
      sortableStatus: null,
      dragEvent: null,
      draggedRecord: null,
    }
  },
  computed: {
    statusRecords() {
      return this.$store.getters['activeState/recordsByStatusId'](this.status.id);
    },
    records() {
      return this.$store.getters['activeState/records'];
    },
    statuses: {
      get() {
        return this.$store.getters["pipeline/activeStatusesInView"];
      },
      set(statuses) {
        this.$store.commit('setStatuses', statuses);
      }
    }
  },
  mounted() {
    let vm = this;

    this.sortableStatus = Sortable.create(document.getElementById('status' + this.status.id), {
      group: 'statuses',
      handle: '.handle',
      animation: 100,
      sort: false,
      filter: '.undraggable',
      ghostClass: 'display-none',

      onAdd(event) {
        const recordId = parseInt(event.clone.attributes['data-record-id'].value);

        vm.dragEvent = event;
        vm.draggedRecord = JSON.parse(JSON.stringify(vm.records.find(r => r.id === recordId)));

        const incompleteRequiredTasks = vm.$store.getters.pipelineIncompleteTasks.filter(a => a.record_id === vm.draggedRecord.id && a.is_required_to_change_status);

        if (incompleteRequiredTasks.length) {
          vm.$buefy.snackbar.open({
            message: 'Cannot change status with incomplete required tasks',
            type: 'is-danger',
            position: 'is-bottom',
            indefinite: true
          });

          vm.moveRecordBack();

          return;
        }

        // if (!vm.status.acceptable_time) {
        //   vm.isRecordRequiredDateModalOpen = true;
        // } else {
          vm.update(null);
        // }
      },
    });
  },
  methods: {
    playAddAnimation() {
      const vm = this;

      TweenMax.set(this.dragEvent.to, {
        boxShadow: '0px 15px 5px 0px rgba(0, 175, 0, 0), 0px 15px 5px 0px rgba(0, 175, 0, 0)',
      });

      TweenMax.to(this.dragEvent.to, 0.2, {
        boxShadow: '0px 15px 5px 0px rgba(0, 175, 0, 1), 0px 15px 5px 0px rgba(0, 175, 0, 1)',
        ease: 'power.4.out',
        onComplete() {
          TweenMax.to(vm.dragEvent.to, 0.2, {
            boxShadow: '0px 15px 5px 0px rgba(0, 175, 0, 0), 0px 15px 5px 0px rgba(0, 175, 0, 0)',
            ease: 'power.4.in',
          });
        }
      });
    },
    moveRecordBack() {
      const p = this.dragEvent.from;
      p.insertBefore(this.dragEvent.item, p.children[this.dragEvent.oldIndex]);
    },
    update(requiredDate) {
      const oldRecord = { ...this.draggedRecord, active_status: {...this.draggedRecord.active_status} };
      const parent = this.dragEvent.to;
      const loader = document.getElementById('pipeline-record-loader-' + this.draggedRecord.id);
      const card = document.getElementById('pipeline-record-' + this.draggedRecord.id);

      parent.append(this.dragEvent.item);
      card.classList.add('undraggable');
      loader.style.opacity = 0.5;
      this.playAddAnimation();

      this.$api.records.changeStatus(this.draggedRecord.id, this.status.id, requiredDate, null)
        .then(() => {})
        .catch(() => { this.moveRecordBack() })
        .finally(() => {
          loader.style.opacity = 0;
          card.classList.remove('undraggable');
        })
    },
  }
}
</script>
